export enum StatusCodeEnum {
  SUCCESS = 200,
  CREATE_SUCCESS= 201,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  USER_DUPLICATED = 409,
  INTERNAL_SERVER_ERROR = 500,
}
